module.exports = __webpack_public_path__ + "assets/bf9058d782bc20eba127d3d4e2679f12.svg";